<template>
  <div class="login">
	<!-- 顶部导航 -->
	<div class="login-top">
		<div class="logo">
			<div class="logo-badge">
				<img src="/logo.png" alt="Logo" class="logo-img">
			</div>
			<div class="logo-text">
				<div class="logo-name">青少年人工智能高水平创新人才培养 课程平台</div>
				<div class="logo-slogan">Youth AI High-Level Innovative Talent Training</div>
			</div>
		</div>
		<div class="btns">
			<div class="btn-pill-outline" @click="toLogin">去登录</div>
			<div class="btn-grad btn-grad-sm" @click="toTeacherRegister">教师入驻</div>
		</div>
	</div>
	<!-- 主体区域 -->
	<div class="login-center">
		<!-- 左侧：品牌宣传区 -->
		<div class="login-hero">
			<div class="deco deco-1"></div>
			<div class="deco deco-2"></div>
			<div class="deco-ring"></div>

			<div class="hero-content">
				<div class="hero-tag"><i class="el-icon-star-on"></i>加入我们，开启 AI 学习之旅</div>
				<div class="hero-title">
					加入平台<br>遇见<span class="hero-highlight">更聪明的自己</span>
				</div>
				<div class="hero-desc">注册即可加入班级课程、观看趣味视频、<br>完成编程挑战，和老师同学们一起成长。</div>
				<div class="hero-points">
					<div class="hero-point"><i class="el-icon-collection"></i>免费课程资源</div>
					<div class="hero-point"><i class="el-icon-data-analysis"></i>学习进度跟踪</div>
					<div class="hero-point"><i class="el-icon-present"></i>成长积分奖励</div>
				</div>
				<!-- 火箭插画 -->
				<svg class="rocket" width="150" height="160" viewBox="0 0 150 160" fill="none">
					<ellipse cx="75" cy="150" rx="44" ry="7" fill="rgba(0,0,0,0.18)"/>
					<path d="M75 12 C95 34 100 62 94 92 L56 92 C50 62 55 34 75 12Z" fill="#FFFFFF"/>
					<circle cx="75" cy="52" r="12" fill="#2B3A67"/>
					<circle cx="75" cy="52" r="7" fill="#4DE1FF"/>
					<path d="M56 78 L36 102 L56 96 Z" fill="#FF9F43"/>
					<path d="M94 78 L114 102 L94 96 Z" fill="#FF9F43"/>
					<path d="M63 92 L87 92 L82 112 L68 112 Z" fill="#C9D2FF"/>
					<path d="M70 116 Q75 132 80 116 Q78 126 75 130 Q72 126 70 116Z" fill="#FFE066"/>
					<circle cx="34" cy="40" r="4" fill="rgba(255,255,255,0.6)"/>
					<circle cx="120" cy="52" r="5" fill="rgba(255,255,255,0.5)"/>
				</svg>
			</div>
		</div>
		<!-- 右侧：注册表单卡片 -->
		<div class="login-form">
			<div class="form-card">
				<div class="form-head">
					<div class="form-title">创建账号</div>
					<div class="form-sub">填写信息，成为平台小学员</div>
				</div>
				<el-form :model="userInfo" :rules="rules" ref="ruleForm" class="reg-form-el">
					<el-form-item prop="userName">
						<el-input v-model="userInfo.userName" placeholder="请输入姓名（昵称）" prefix-icon="el-icon-user"></el-input>
					</el-form-item>
					<el-form-item prop="loginAccount">
						<el-input v-model="userInfo.loginAccount" placeholder="请输入登录账号" prefix-icon="el-icon-postcard"></el-input>
					</el-form-item>
					<el-form-item prop="password">
						<el-input type="password" v-model="userInfo.password" placeholder="请输入用户密码" prefix-icon="el-icon-lock"></el-input>
					</el-form-item>
					<el-form-item prop="passwordNew">
						<el-input type="password" v-model="userInfo.passwordNew" placeholder="请再次输入密码确认" prefix-icon="el-icon-key"></el-input>
					</el-form-item>
				</el-form>
				<div class="btn-grad reg-btn" @click="toRegister()">立即注册</div>
				<div class="form-foot">
					<span>已有账号？</span>
					<span class="link" @click="toLogin">直接登录</span>
				</div>
			</div>
		</div>
	</div>
	<bottomPage></bottomPage>
  </div>
</template>

<script>
  import {register} from '../../api/api' 
  import bottomPage from "../../components/bottom/login-bottom"
  export default {
	data() {
	  return{
		userInfo: {
			userName: "",
			password: "",
			passwordNew: "",
			loginAccount: "",
			userType: 2
		},
		rules: {
          userName: [
            { required: true, message: '请输入名', trigger: 'blur' },
          ],
          password: [
            { required: true, message: '请输入用户密码', trigger: 'blur' }
		  ],
		  passwordNew: [
            { required: true, message: '请输入确认密码', trigger: 'blur' }
		  ],
		  loginAccount: [
            { required: true, message: '请输入用户账号', trigger: 'blur' }
		  ],
        }
	  }
	},
	components: {
        bottomPage
	},
	methods: {
		toLogin() {
			this.$router.push("/login")
		},
		toTeacherRegister() {
			this.$router.push("/teacherRegister")
		},
		toRegister() {
			this.$refs["ruleForm"].validate((valid) => {
				if (valid) {
					if (this.userInfo.password != this.userInfo.passwordNew) {
						this.$message({
							message: '两次输入的密码不一致！',
							type: 'warning'
						});
						return;
					}
					register(this.userInfo).then(res => {
						if(res.code == 1000) {
							this.$message({
								message: '注册成功',
								type: 'success'
							});
							var that = this
							setTimeout(function() {
								that.$router.push("/login")
							},500)
						} else {
							this.$message.error(res.message);
						}
					})
				} else {
					return false;
				}
			});
		}
	},
	created() {
	 
	},
	mounted() {
	  
	}
 }
</script>

<style scoped>
  .login {
	  width: 100%;
	  min-height: 100%;
	  display: flex;
	  flex-direction: column;
	  background: var(--bg-page);
  }
  .login-top {
	  height: 84px;
	  display: flex;
	  align-items: center;
	  justify-content: space-between;
	  padding: 0 60px;
	  flex-shrink: 0;
  }
  .logo {
	  display: flex;
	  align-items: center;
  }
  .logo-badge {
	  width: 48px;
	  height: 48px;
	  border-radius: 14px;
	  background: #FFFFFF;
	  display: flex;
	  align-items: center;
	  justify-content: center;
	  box-shadow: 0 6px 16px rgba(91, 108, 255, 0.35);
	  overflow: hidden;
  }
  .logo-img {
	  width: 100%;
	  height: 100%;
	  object-fit: cover;
	  border-radius: 14px;
  }
  .logo-text { margin-left: 12px; }
  .logo-name {
	  font-size: 20px;
	  font-weight: 700;
	  background: var(--grad-primary);
	  -webkit-background-clip: text;
	  background-clip: text;
	  color: transparent;
	  letter-spacing: 1px;
  }
  .logo-slogan {
	  margin-top: 2px;
	  font-size: 12px;
	  color: var(--text-sub);
  }
  .btns { display: flex; align-items: center; gap: 16px; }
  .btn-grad-sm {
	  height: 40px;
	  padding: 0 26px;
	  font-size: 15px;
	  letter-spacing: 2px;
  }
  .login-center {
	  flex: 1;
	  margin: 10px 60px 40px;
	  border-radius: var(--radius-lg);
	  overflow: hidden;
	  display: flex;
	  box-shadow: var(--shadow-card);
  }
  .login-hero {
	  position: relative;
	  width: 56%;
	  background: var(--grad-hero);
	  display: flex;
	  align-items: center;
	  overflow: hidden;
  }
  .hero-content {
	  position: relative;
	  z-index: 2;
	  padding: 44px 70px;
	  color: #FFFFFF;
  }
  .hero-tag {
	  display: inline-flex;
	  align-items: center;
	  gap: 6px;
	  padding: 7px 18px;
	  border-radius: 999px;
	  background: rgba(255, 255, 255, 0.16);
	  border: 1px solid rgba(255, 255, 255, 0.30);
	  font-size: 13px;
	  letter-spacing: 1px;
  }
  .hero-title {
	  margin-top: 24px;
	  font-size: 42px;
	  font-weight: 700;
	  line-height: 1.3;
	  letter-spacing: 2px;
  }
  .hero-highlight {
	  background: linear-gradient(135deg, #FFE066 0%, #FFB020 100%);
	  -webkit-background-clip: text;
	  background-clip: text;
	  color: transparent;
  }
  .hero-desc {
	  margin-top: 18px;
	  font-size: 15px;
	  line-height: 1.9;
	  color: rgba(255, 255, 255, 0.85);
	  letter-spacing: 1px;
  }
  .hero-points { margin-top: 26px; display: flex; gap: 14px; flex-wrap: wrap; }
  .hero-point {
	  display: flex;
	  align-items: center;
	  gap: 7px;
	  padding: 10px 18px;
	  border-radius: 999px;
	  background: rgba(255, 255, 255, 0.14);
	  border: 1px solid rgba(255, 255, 255, 0.22);
	  font-size: 14px;
	  letter-spacing: 1px;
  }
  .hero-point i { color: #FFE066; font-size: 16px; }
  .rocket {
	  margin-top: 30px;
	  animation: float 3.2s ease-in-out infinite;
  }
  .deco { position: absolute; border-radius: 50%; z-index: 1; }
  .deco-1 {
	  width: 340px; height: 340px; right: -90px; top: -90px;
	  background: radial-gradient(circle, rgba(255,255,255,0.16) 0%, rgba(255,255,255,0) 70%);
  }
  .deco-2 {
	  width: 260px; height: 260px; left: -70px; bottom: -70px;
	  background: radial-gradient(circle, rgba(255, 224, 102, 0.22) 0%, rgba(255,255,255,0) 70%);
  }
  .deco-ring {
	  position: absolute;
	  width: 130px; height: 130px; right: 50px; top: 60px;
	  border: 14px solid rgba(255, 255, 255, 0.10);
	  border-radius: 50%;
	  z-index: 1;
  }
  .login-form {
	  width: 44%;
	  background: #FFFFFF;
	  display: flex;
	  align-items: center;
	  justify-content: center;
	  position: relative;
  }
  .login-form::before {
	  content: '';
	  position: absolute;
	  width: 180px; height: 180px; right: -50px; top: -50px;
	  border-radius: 50%;
	  background: radial-gradient(circle, rgba(91, 108, 255, 0.08) 0%, rgba(255,255,255,0) 70%);
  }
  .form-card { width: 70%; position: relative; z-index: 2; padding: 20px 0; }
  .form-title {
	  font-size: 28px;
	  font-weight: 700;
	  color: var(--text-main);
	  letter-spacing: 1px;
  }
  .form-sub {
	  margin-top: 10px;
	  margin-bottom: 28px;
	  font-size: 14px;
	  color: var(--text-sub);
	  letter-spacing: 1px;
  }
  .reg-form-el >>> .el-input__inner {
	  height: 46px;
	  line-height: 46px;
	  border-radius: 12px;
	  background: #F7F8FE;
	  border-color: #EDEFF9;
  }
  .reg-form-el >>> .el-input__inner:focus {
	  background: #FFFFFF;
	  border-color: var(--primary);
  }
  .reg-form-el >>> .el-form-item { margin-bottom: 20px; }
  .reg-btn { width: 100%; margin-top: 4px; }
  .form-foot {
	  margin-top: 20px;
	  text-align: center;
	  font-size: 14px;
	  color: var(--text-sub);
  }
  .form-foot .link {
	  color: var(--primary);
	  font-weight: 600;
	  cursor: pointer;
	  margin-left: 6px;
  }
  .form-foot .link:hover { text-decoration: underline; }
  @keyframes float {
	  0%, 100% { transform: translateY(0); }
	  50% { transform: translateY(-12px); }
  }
</style>
